import React from 'react';
import { Helmet } from 'react-helmet-async';


export default function Privacy() {


  return <div>
    <Helmet>
      <title>Crossworthy Privacy Policy</title>
      <meta name='description' content='We are fully independent, free, and do not track or sell any of your data behind the scenes.' />
    </Helmet>

    <div className='d-flex m-3'>
      <div className='mx-auto not-too-wide'>
        <h2 className='mt-5'>Our Crossworthy privacy policy</h2>

        <p>
          Hey there! Welcome to Crossworthy.
          We're an independent web app fully focused on making it fun to create and play crosswords.
          We don't track any of your data beyond the little we need to make the site function. And we'll certainly never disclose or sell any of your personal data!
        </p>
        <p>
          If you're curious, let's chat more privacy details below. For more info about Crossworthy, head to our <a href='/about'>About Us</a> page as well.
        </p>

        <hr />

        <p>
          Updated: November 17, 2025
        </p>

        <strong>Puzzle Sharing</strong>
        <p>
          By default, any puzzles you create are viewable/solvable by anyone with the link, but we do not publish or share those links anywhere.
          You can restrict or expand access to your puzzle(s) by clicking the blue "Share" button while constructing.
          If you make a puzzle private, nobody else, except explicit accounts designated by you, can view or access the puzzle.
        </p>
        <p>
          The same policies apply to collections you publish on Crossworthy.
        </p>

        <strong>Personal Data</strong>
        <p>
          We only collect the basics: if you sign up for an account, we'll associate all your puzzles with an email you provide.
          While using the site, you may save additional personal information in various places (e.g. sign your puzzles with your full name), but Crossworthy does not track any of this.
        </p>
        <p>
          Separately, you may also provide your email to sign up for email notifications from various puzzlemakers, including us.
        </p>

        <strong>How We Use Your Info</strong>
        <p>
          We associate your account (and all the puzzles you create or play) with your email.
          That email will be used to receive one-time login codes or notifications if a puzzle is shared with, or requested of, you.
          De-identified play statistics may also be available to constructors who publish their puzzles on Crossworthy.
          If our website crashes or malfunctions, we may save a report to assist our debugging efforts, which may contain general information about your email, browser type, or internet service provider.
          If necessary to address an issue with your account or puzzle, or if you contact us first, we may use your email to write to you.
        </p>

        <strong>Sharing Secrets? Nope!</strong>
        <p>
          We don't share, sell, or otherwise disclose the information you provide.
          When you share a puzzle you create with collaborators, for instance, they will be able to see your email and chosen display name.
          Please note that if a collaborator adds your email to a shared puzzle, that email will be visible to other collaborators as well.
        </p>

        <strong>How We Keep It Secure</strong>
        <p>
          Our authentication, authorization and storage stack is backed by secure, robust, industry-standard technology.
          However, please note that no method of transmission over the internet or electronic storage is ever guaranteed to be perfectly secure.
        </p>

        <strong>Milk and Cookies</strong>
        <p>
          We only use necessary cookies to maintain your authentication. No sneaky trackers.
        </p>

        <strong>Future Updates</strong>
        <p>
          We're constantly thinking up ways to improve the Crossworthy experience, but we'll keep this page updated with any changes.
        </p>
        
        <strong>Got questions?</strong>
        <p>
          We're here to answer them! Use our email or our <a href='/feedback'>feedback page</a> to get in touch.
        </p>
      </div>

    </div>
    <div className='text-center my-4'>
      <img src='/android-chrome-256x256.png' alt='crossworthy-logo' width='50px' />
    </div>
  </div>;
}